import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useQueryParams } from 'use-query-params'

import { getRules } from '../../api/rules'
import useApiCall from '../../api/useApiCall'
import { buildQuery, DashArrayParam } from '../../utils/useQueryParams'
import LoadingSection from '../LoadingSection/LoadingSection'

import RuleContent from './RuleContent/RuleContent'
import { RulesFiltersEnum } from './RulesFilters/RulesFilters'

import styles from './rules.module.scss'

export interface IRuleOption {
    name: string
    _id: string
}

function Rules() {
    const { ruleId } = useParams()

    const navigate = useNavigate()

    const [query] = useQueryParams({
        [RulesFiltersEnum.INTENTS]: DashArrayParam,
        [RulesFiltersEnum.ACTIONS]: DashArrayParam,
    })

    const [rules, setRules] = useState<IRuleOption[]>([])

    const [{ loading }] = useApiCall(getRules, handleGetRules, query || '')

    function handleGetRules(rules: IRuleOption[]) {
        setRules(rules)

        const [defaultRule] = rules

        const doRulesNotIncludeRule =
            ruleId && !rules.map((rule) => rule.name).includes(ruleId)

        if (doRulesNotIncludeRule) {
            navigate({
                pathname: `/rules/${defaultRule._id}`,
                search: buildQuery(query),
            })
        }

        if (!ruleId) {
            navigate({
                pathname: `/rules/${defaultRule._id}`,
            })
        }
    }

    return (
        <main className={styles.rules}>
            {loading ? (
                <LoadingSection />
            ) : (
                <RuleContent rules={rules} setRules={setRules} />
            )}
        </main>
    )
}

export default Rules
